import React, { CSSProperties } from "react";

interface Props {
  airlineCode: string;
  style?: CSSProperties;
}

function AirlineLogo({ airlineCode, style }: Props) {
  return (
    <img
      className="airline-logo"
      src={`https://tracker.flightview.com/FVAccess3/tools/routemapper2/img/tail_logos/${airlineCode}.png`}
      onError={(e) => {
        const element = e.target as HTMLImageElement;
        element.src = `https://tracker.flightview.com/FVAccess3/tools/routemapper2/img/tail_logos/default.gif`;
      }}
      style={style}
      alt="Airline Logo"
      width={40}
      height={32}
      tabIndex={-1}
    />
  );
}

export default AirlineLogo;
